import styles from "./main-app-menu.module.css";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { useAppScroll } from "use-app-scroll";
import { useEffect } from "react";

interface MainAppMenuButtonProps {
  label: string;
  subtitle?: string;
  icon: UIIconName;
  onClick: () => void;
}

export const MenuOption = (props: MainAppMenuButtonProps) => {
  const { scrolled, setScrolled } = useAppScroll();

  return (
    <button className={styles.menuAction} onClick={props.onClick}>
      <UIIcon iconName={props.icon} variant="REGULAR" size={20} />
      <div className={styles.labels}>
        {props.label}
        {props.subtitle && (
          <span className={styles.subtitle}>{props.subtitle}</span>
        )}
      </div>
    </button>
  );
};
